import React from 'react';



type Props = {
  className?: string;
}
export const ClockVector: React.FC<Props> = ({ className }) => {
  return (
    <svg width = '20' height = '20' viewBox = '0 0 20 20' fill = 'none' xmlns = 'http://www.w3.org/2000/svg'>
      <path stroke = 'currentColor' strokeWidth = '1.6' strokeLinecap = 'round' strokeLinejoin = 'round' d = 'M9.80078 18.8C14.7713 18.8 18.8008 14.7706 18.8008 9.80005C18.8008 4.82949 14.7713 0.800049 9.80078 0.800049C4.83022 0.800049 0.800781 4.82949 0.800781 9.80005C0.800781 14.7706 4.83022 18.8 9.80078 18.8Z' />
      <path stroke = 'currentColor' strokeWidth = '1.6' strokeLinecap = 'round' strokeLinejoin = 'round' d = 'M6.80078 9.80005H9.80078L12.8008 6.80005' />
    </svg>
  );
};
